import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"c-loading__inner -search\"><div class=\"c-loading\"><svg class=\"c-loading__svg\" width=\"100\" height=\"100\" xmlns=\"http://www.w3.org/2000/svg\"><g><path class=\"c-loading__letters\" d=\"M50.2,58.4c-0.6,0-1.7,0.1-3.1,0.2c-0.3,0-0.6,0-0.9,0.1l-1.8,7.4h5.9l2-7.9C51.5,58.3,50.8,58.4,50.2,58.4\"></path><path class=\"c-loading__letters\" d=\"M80.7,53.3c-1.2,0.4-2.5,0.8-4,1.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0,0.2,0,0.4,0,0.6\n                                    c0,2.5-1.6,5.1-5.2,5.1c-2.4,0-4.7-1-6.8-3.1l-0.4-0.4l-0.1,0.6L61,62.7L61,62.9l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3\n                                    c2.5,1.4,5.3,2.1,8.2,2.1c7.2,0,11-5.1,11-10.1C80.9,54.6,80.8,53.9,80.7,53.3\"></path></g><circle class=\"c-loading__circle\" cx=\"50\" cy=\"50\" r=\"40\" stroke=\"url(#gradient)\" stroke-width=\"5\" fill=\"none\"></circle><defs><linearGradient id=\"gradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\"><stop offset=\"0%\" style=\"stop-color:#E40032;stop-opacity:1;\"></stop><stop offset=\"100%\" style=\"stop-color:#ffffff;stop-opacity:1;\"></stop></linearGradient></defs><g><path class=\"c-loading__letters\" d=\"M40.8,38.1H23.2l-7.9,31.7h17.8l1.2-4.9H22.4l2.3-9.1h10.1l1.2-4.9H25.9l2-7.9h11.7L40.8,38.1z\"></path><path class=\"c-loading__letters\" d=\"M39.1,30.3c-0.7,0-1.4,0.4-2.7,1.1l-0.1,0.1L30,35.2l-0.9,0.5l1,0.1l1.4,0.1h0.1l0.1,0l7.1-2.2\n                                    c0.8-0.2,1.6-0.5,1.9-1.4c0.1-0.4,0-0.8-0.2-1.2c-0.2-0.4-0.5-0.6-0.9-0.8C39.4,30.3,39.2,30.3,39.1,30.3\"></path><path class=\"c-loading__letters\" d=\"M43.3,34.5l-1.2,4.9H51l-0.2,0.8l-4,16.2c0.3,0,0.6,0,0.9-0.1c1-0.1,1.9-0.1,2.3-0.2c0.9-0.1,1.8-0.2,2.8-0.2\n                                    l4.1-16.5h8.3l1-4.1l0.2-0.8L43.3,34.5L43.3,34.5z\"></path><path class=\"c-loading__letters\" d=\"M84.5,34.4c-2.9-1.7-5.7-2.1-7.5-2.1c-3,0-5.7,1-7.5,2.9c-1.7,1.7-2.6,4.1-2.6,6.5c0,2.8,1.2,4.8,2.7,6.4\n                                    c0.7,0.8,1.5,1.5,2.2,2.1c0.7,0.6,1.3,1.3,1.9,2c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0,0.1,0c0.6-0.2,1.3-0.3,1.9-0.5\n                                    c1.4-0.4,2.7-0.7,3.8-1.1c-0.3-0.6-0.7-1.1-1.1-1.6c-0.6-0.7-1.2-1.3-1.7-1.9l0,0l-0.9-0.9c-0.5-0.4-1-0.9-1.5-1.4\n                                    c-1-1.1-1.9-2.4-1.9-3.9c0-2.1,1.6-4.4,4.6-4.4c1.1,0,3.3,0.3,5.6,2.5l0.4,0.4l0.1-0.5l1.1-4.5l0-0.1l0.1-0.2L84.5,34.4L84.5,34.4z\n                                    \"></path></g></svg></div></div>", 1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "o-form__item__container" }
const _hoisted_5 = {
  key: 0,
  class: "o-form__item"
}
const _hoisted_6 = {
  class: "o-label",
  for: "equipement-search"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 1,
  class: "o-form__item"
}
const _hoisted_9 = {
  class: "o-label sr-only",
  for: "equipement-search"
}
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=5#search" })
], -1 /* HOISTED */)
const _hoisted_12 = {
  key: 2,
  class: "o-form__item"
}
const _hoisted_13 = {
  class: "o-label sr-only",
  for: "domains"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=5#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_17 = {
  key: 3,
  class: "o-form__item"
}
const _hoisted_18 = {
  class: "o-label sr-only",
  for: "categories"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=5#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_22 = { class: "o-form__button c-tooltip__wrap" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-full-right"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=5#arrow-full-right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-full-right"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=5#arrow-full-right" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_24 = { class: "o-button__text" }
const _hoisted_25 = { class: "o-button__text__elm" }
const _hoisted_26 = {
  key: 0,
  class: "sr-only"
}
const _hoisted_27 = {
  key: 1,
  class: "sr-only"
}
const _hoisted_28 = { class: "c-tooltip" }
const _hoisted_29 = {
  key: 0,
  class: "c-tooltip__text"
}
const _hoisted_30 = {
  key: 1,
  class: "c-tooltip__text"
}
const _hoisted_31 = {
  key: 0,
  class: "c-programmes-search__filters"
}
const _hoisted_32 = { class: "o-container" }
const _hoisted_33 = { class: "c-programmes-search__filters__wrap" }
const _hoisted_34 = {
  key: 0,
  class: "c-programmes-search__filters__total"
}
const _hoisted_35 = {
  key: 1,
  class: "c-programmes-search__filters__actives"
}
const _hoisted_36 = { class: "c-programmes-search__filters__actives__item" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "sr-only" }
const _hoisted_41 = {
  key: 2,
  class: "c-programmes-search__filters__reset"
}
const _hoisted_42 = { ref: "resultsStart" }
const _hoisted_43 = { class: "o-section__inner" }
const _hoisted_44 = { class: "o-container" }
const _hoisted_45 = { class: "o-grid o-people -grid-no-row-gap" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "o-people__item__strokes" }, null, -1 /* HOISTED */)
const _hoisted_48 = { class: "o-people__img" }
const _hoisted_49 = {
  key: 0,
  class: "o-responsive-img -fit -center-center",
  style: {"padding-top":"100%"}
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  class: "o-img -fit -center-center",
  src: "/assets/img/placeholder.jpeg",
  alt: "No image"
}, null, -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", { class: "c-tooltip__indicator" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("button", {
  class: "c-modal__close",
  autofocus: ""
}, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_55 = { class: "c-modal__content" }
const _hoisted_56 = { class: "c-modal__item is-active" }
const _hoisted_57 = { class: "c-modal__text" }
const _hoisted_58 = { class: "o-title-4" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = ["href"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      "aria-hidden": "true",
      tabindex: "-1",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      "aria-hidden": "true",
      tabindex: "-1",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_62 = { class: "o-button__text" }
const _hoisted_63 = { class: "o-button__text__elm" }
const _hoisted_64 = { class: "sr-only" }
const _hoisted_65 = { class: "o-title-4 o-people__name" }
const _hoisted_66 = { class: "o-people__role" }
const _hoisted_67 = ["href"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      "aria-hidden": "true",
      tabindex: "-1",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      "aria-hidden": "true",
      tabindex: "-1",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_69 = { class: "o-button__text" }
const _hoisted_70 = { class: "o-button__text__elm" }
const _hoisted_71 = { class: "sr-only" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pager = _resolveComponent("Pager")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-programmes-search", [$props.background]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["o-form -form-preload", { '-loading': $data.loading }])
        }, [
          _hoisted_2,
          _createCommentVNode(" {{ domains }} "),
          _createCommentVNode(" {{ labs }} "),
          ($data.title != '')
            ? (_openBlock(), _createElementBlock("h2", {
                key: 0,
                class: "o-title-4",
                innerHTML: $data.title
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.prof == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    onKeyup: _cache[0] || (_cache[0] = $event => ($options.keyupSearch())),
                    class: "o-input",
                    id: "equipement-search",
                    type: "text",
                    placeholder: $options.t("Nom, prénom, téléphone, poste, local"),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchInput) = $event))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
                    [_vModelText, $data.searchInput]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    onKeyup: _cache[2] || (_cache[2] = $event => ($options.keyupSearch())),
                    class: "o-input",
                    id: "equipement-search",
                    type: "text",
                    placeholder: $options.t("Mots clés"),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.searchInput) = $event))
                  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10), [
                    [_vModelText, $data.searchInput]
                  ]),
                  _hoisted_11
                ])),
            ($data.domains.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString($options.t("Domaines")), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("select", {
                    onChange: _cache[4] || (_cache[4] = $event => ($options.changeSelectionDomain())),
                    class: "o-select",
                    id: "domains",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedDomain) = $event))
                  }, [
                    _createElementVNode("option", {
                      value: "",
                      innerHTML: $options.t(`Domaines`)
                    }, null, 8 /* PROPS */, _hoisted_14),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.domains, (domain) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: domain.id
                      }, _toDisplayString(domain.title), 9 /* TEXT, PROPS */, _hoisted_15))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, $data.selectedDomain]
                  ]),
                  _hoisted_16
                ]))
              : _createCommentVNode("v-if", true),
            ($data.categories.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString($options.t("Catégories")), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("select", {
                    onChange: _cache[6] || (_cache[6] = $event => ($options.changeSelectionCategory())),
                    class: "o-select",
                    id: "categories",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.selectedCategory) = $event))
                  }, [
                    _createElementVNode("option", {
                      value: "",
                      innerHTML: $options.t(`Catégories`)
                    }, null, 8 /* PROPS */, _hoisted_19),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (category) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: category.id
                      }, _toDisplayString(category.title), 9 /* TEXT, PROPS */, _hoisted_20))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, $data.selectedCategory]
                  ]),
                  _hoisted_21
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" <div v-if=\"labs.length\" class=\"o-form__item\">\n                        <label class=\"o-label sr-only\" for=\"labs\">{{ t(\"Laboratoires\") }}</label>\n                        <select @change=\"changeSelectionAxe()\" class=\"o-select\" id=\"labs\" v-model=\"selectedLab\">\n                            <option value=\"\">{{ t(\"Laboratoire\") }}</option>\n                            <option v-for=\"lab in labs\" :value=\"lab.id\">{{ lab.title }}</option>\n                        </select>\n                        <svg class=\"o-ico -ico-arrow-down\" role=\"img\">\n                            <title>arrow-down</title>\n                            <use xlink:href=\"/assets/img/sprite.svg?v=5#arrow-down\"></use>\n                        </svg>\n                    </div> "),
            _createElementVNode("div", _hoisted_22, [
              ($props.target)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[8] || (_cache[8] = _withModifiers($event => ($options.refreshUrlQuery()), ["prevent"])),
                    class: "o-button -button-bg",
                    type: "submit"
                  }, [
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, [
                        _createTextVNode(_toDisplayString($options.t("Rechercher")) + " ", 1 /* TEXT */),
                        (!_ctx.prof)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($options.t("une personne selon les critères sélectionnés")), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString($options.t("un professeur selon les critères sélectionnés")), 1 /* TEXT */))
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_28, [
                (!$props.target)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString($options.t("Voir les")) + " " + _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString($options.t("Voir les")) + " " + _toDisplayString($options.t("résultats")), 1 /* TEXT */))
              ])
            ])
          ])
        ], 2 /* CLASS */)
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["c-search-filters-results", { '-loading': $data.loading }])
    }, [
      _createCommentVNode(" <div class=\"c-search-filters-results\" :class=\"{ '-loading': loading, '-noresults': filteredResults.length === 0 }\"> "),
      ($options.filteredResults.length || $options.tags.length || $data.searchInput.length >= 3 || $data.selectedLabs.length || $data.selectedDomains.length || $data.selectedCategories.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                (!$props.target && ($data.searchInput.length >= 3 || $data.selectedLabs.length > 0 || $data.selectedDomains.length > 0 || $data.selectedCategories.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("span", null, _toDisplayString($options.filteredResults.length) + " " + _toDisplayString($options.t("résultat")) + _toDisplayString($options.filteredResults.length > 1 ? 's' : ''), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($options.tags.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("span", null, _toDisplayString(tag.title), 1 /* TEXT */),
                          _createElementVNode("button", {
                            onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"]),
                            class: "c-programmes-search__filters__remove"
                          }, [
                            _hoisted_38,
                            _hoisted_39,
                            _createElementVNode("span", _hoisted_40, _toDisplayString($options.t("Retirer le filtre")) + " : " + _toDisplayString(tag.title), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_37)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (!$props.target && ($options.tags.length > 0 || $data.searchInput.length >= 3))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("button", {
                        onClick: _cache[9] || (_cache[9] = _withModifiers($event => ($options.resetSearch()), ["prevent"])),
                        class: "o-button -button-reset"
                      }, _toDisplayString($options.t("Réinitialiser la recherche")), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_42, null, 512 /* NEED_PATCH */),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredResultsPaged, (entry) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "o-grid-4 o-people__item c-tooltip__wrap",
                onClick: $event => ($options.openModal($event, entry))
              }, [
                _hoisted_47,
                _createCommentVNode(" <div class=\"o-people__img\" v-if=\"entry.photo\" v-html=\"entry.photo\"></div> "),
                _createElementVNode("div", _hoisted_48, [
                  (!entry.photo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _hoisted_51))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        innerHTML: entry.photo
                      }, null, 8 /* PROPS */, _hoisted_52)),
                  (entry.description && entry.description!='')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" <span v-html=\"entry.description\"></span> "),
                        _hoisted_53,
                        _createElementVNode("dialog", {
                          class: "c-modal",
                          "data-lenis-prevent": "",
                          onClick: _cache[11] || (_cache[11] = _withModifiers($event => ($options.closeModal($event)), ["stop"]))
                        }, [
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("h3", _hoisted_58, _toDisplayString(entry.title), 1 /* TEXT */),
                                _createElementVNode("div", {
                                  innerHTML: entry.description
                                }, null, 8 /* PROPS */, _hoisted_59),
                                _createElementVNode("a", {
                                  onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                  href: entry.url,
                                  class: "o-button o-box-cta__btn -button-text",
                                  target: "_self",
                                  rel: ""
                                }, [
                                  _hoisted_61,
                                  _createElementVNode("span", _hoisted_62, [
                                    _createElementVNode("span", _hoisted_63, [
                                      _createTextVNode(_toDisplayString($options.t('Voir la fiche complète')) + " ", 1 /* TEXT */),
                                      _createElementVNode("span", _hoisted_64, _toDisplayString($options.t("Fiche complète de l'équipement")), 1 /* TEXT */)
                                    ])
                                  ])
                                ], 8 /* PROPS */, _hoisted_60)
                              ])
                            ])
                          ])
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("h3", _hoisted_65, [
                  _createElementVNode("span", null, _toDisplayString(entry.title), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_66, _toDisplayString(entry.domaines.map(domaine => domaine.title).join(', ')), 1 /* TEXT */),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.labs, (lab, lindex) => {
                  return (_openBlock(), _createElementBlock("p", { key: lindex }, _toDisplayString(lab.title), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("a", {
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"])),
                  href: entry.url,
                  class: "o-button o-box-cta__btn -button-text",
                  target: "_self",
                  rel: ""
                }, [
                  _hoisted_68,
                  _createElementVNode("span", _hoisted_69, [
                    _createElementVNode("span", _hoisted_70, [
                      _createTextVNode(_toDisplayString($options.t('Voir la fiche complète')) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_71, _toDisplayString($options.t("Fiche complète de l'équipement")), 1 /* TEXT */)
                    ])
                  ])
                ], 8 /* PROPS */, _hoisted_67)
              ], 8 /* PROPS */, _hoisted_46))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          ($data.pagerInfo.totalPages > 1)
            ? (_openBlock(), _createBlock(_component_Pager, {
                key: 0,
                pagerInfo: $data.pagerInfo,
                onGoToPage: $options.goToPage
              }, null, 8 /* PROPS */, ["pagerInfo", "onGoToPage"]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}